import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthCallback } from "./components/AuthCallback";
import Landing from "./pages/Landing";
import SolutionDetail from "./pages/SolutionDetail";
import IntakeForm from "./pages/IntakeForm";
import ArticlePage from "./pages/ArticlePage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import ConnectivityInquiry from "./pages/ConnectivityInquiry";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash && !hash.includes("session_id=")) {
      const el = document.querySelector(hash);
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function AppRouter() {
  const location = useLocation();
  // Emergent Google Auth callback: session_id arrives in URL fragment
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/solutions/:slug" element={<SolutionDetail />} />
        <Route path="/intake" element={<IntakeForm />} />
        <Route path="/connectivity-inquiry" element={<ConnectivityInquiry />} />
        <Route path="/insights/:slug" element={<ArticlePage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-right" richColors offset={72} />
    </BrowserRouter>
  );
}

export default App;
